// Should be initialized after reverb.attachinary.js
import './reverb.attachinary';

function init() {
  $('[data-attachinary]').each(function () {
    const attachinaryInput = $(this);
    const attachinaryTemplate = attachinaryInput.data('attachinary-template');
    const options = attachinaryTemplate ? { template: $(attachinaryTemplate).html() } : {};
    const attachinaryData = attachinaryInput.data('attachinary');
    const files = attachinaryData.files;

    const previewUrl = $(this).data('preview-url');
    if (previewUrl && files && files.length === 1) {
      files[0].preview_url = previewUrl;
    }

    attachinaryData.files = files;
    attachinaryInput.data('attachinary', attachinaryData);
    attachinaryInput.attachinary(options);
  });
}

$(init);

export default init;
